<mat-card appearance="outlined" class="syn-card" fxLayout="column" fxLayoutAlign="space-around stretch" fxLayoutGap="10px">

    <form [formGroup]="form">

        <mat-table #table [dataSource]="dataSource">

            <!-- scope -->
            <ng-container matColumnDef="scope">
                <mat-header-cell *matHeaderCellDef fxFlex="12"> Scope </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="12">
                    <div fxLayoutGap="5px" fxLayoutAlign="center center">
                        <mat-icon svgIcon="lock-outline" *ngIf="!row.isEditable"></mat-icon>
                        <span [class]="{'icon-margin_left': row.isEditable}">{{tradAssignmentGroupConfigScope[row.scope] || row.scope }}</span>
                    </div>
                </mat-cell>
            </ng-container>

            <!-- ticketType -->
            <ng-container matColumnDef="ticketType">
                <mat-header-cell *matHeaderCellDef fxFlex="11"> Type Ticket </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="11">
                    {{ assignmentGroupConfigTypeShort[row.ticketType] || row.ticketType }}
                </mat-cell>
            </ng-container>

            <!-- assignmentType -->
            <ng-container matColumnDef="assignmentType">
                <mat-header-cell *matHeaderCellDef> Type d'affectation </mat-header-cell>
                <mat-cell *matCellDef="let row">{{ assignmentTypesObject[row.assignmentType] || row.assignmentType }}
                </mat-cell>
            </ng-container>

            <!-- assignmentGroup HO -->
            <ng-container matColumnDef="assignmentGroupHO">
                <mat-header-cell *matHeaderCellDef> Groupe d'affectation HO</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div *ngIf="!row.edit; else edit" class="syn-ellipsis">
                        {{ row.assignmentGroupHO }}
                    </div>
                    <ng-template #edit>
                        <syn-picker
                            placeholder="Groupe d'affectation HO"
                            [ngModel]="row.assignmentGroupObjectHO"
                            [ngModelOptions]="{ standalone: true }"
                            fxFlex="90"
                            [content]="assignmentGroupHO$"
                            [contentLoader]="assignmentGroupLoaderHO"
                            (change)="updateAssignmentGroupConfig(row, $event, 'HO')"
                            [itemTemplate]="itemTemplate">
                        </syn-picker>
                    </ng-template>
                </mat-cell>
            </ng-container>

            <!-- assignmentGroup HNO -->
            <ng-container matColumnDef="assignmentGroupHNO">
                <mat-header-cell *matHeaderCellDef> Groupe d'affectation HNO</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div *ngIf="!row.edit; else edit" class="syn-ellipsis">
                        {{ row.assignmentGroupHNO }}
                    </div>
                    <ng-template #edit>
                        <syn-picker
                            placeholder="Groupe d'affectation HNO"
                            [ngModel]="row.assignmentGroupObjectHNO"
                            [ngModelOptions]="{ standalone: true }"
                            fxFlex="90"
                            [content]="assignmentGroupHNO$"
                            [contentLoader]="assignmentGroupLoaderHNO"
                            (change)="updateAssignmentGroupConfig(row, $event, 'HNO')"
                            [itemTemplate]="itemTemplate">
                        </syn-picker>
                    </ng-template>
                </mat-cell>
            </ng-container>

            <!-- actions -->
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef fxFlex="15"></mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="15">
                    <div *ngIf="row.isEditable && row.hover && canEdit">
                        <button mat-icon-button (click)="editRow(row)">
                            <mat-icon svgIcon="pencil-outline"></mat-icon>
                        </button>
                        <button mat-icon-button (click)="openDeleteDialog(row)">
                            <mat-icon svgIcon="delete-outline"></mat-icon>
                        </button>
                    </div>

                </mat-cell>
            </ng-container>

            <!-- creation line -->
            <ng-container matColumnDef="scopeForm">
                <mat-header-cell *matHeaderCellDef fxFlex="12">
                </mat-header-cell>
            </ng-container>

            <ng-container matColumnDef="ticketTypeForm">
                <mat-header-cell *matHeaderCellDef class="syn--padding-right__small" fxFlex="11">
                    <mat-form-field fxFlex="100" appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Type</mat-label>
                        <mat-select formControlName="ticketType" placeholder="Type">
                            @for (type of assignmentGroupConfigTicketType; track type.value) {
                                <mat-option [value]="type.value">{{ type.text }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </mat-header-cell>
            </ng-container>

            <ng-container matColumnDef="assignmentTypeForm">
                <mat-header-cell *matHeaderCellDef class="syn--padding-right">
                    <mat-form-field fxFlex="100" appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Type d'affectation</mat-label>
                        <mat-select formControlName="assignmentType" placeholder="Type d'affectation">
                            @for (assignmentType of assignmentTypes; track assignmentType.value) {
                                <mat-option [value]="assignmentType.value">{{ assignmentType.text }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </mat-header-cell>
            </ng-container>

            <ng-container matColumnDef="assignmentGroupHOForm">
                <mat-header-cell *matHeaderCellDef class="syn--padding-right">
                    <syn-picker
                        placeholder="Groupe d'affectation HO"
                        formControlName="assignmentGroupHO"
                        fxFlex="100"
                        subscriptSizing="dynamic"
                        [content]="assignmentGroupHOFooter$"
                        [contentLoader]="assignmentGroupLoaderHOFooter"
                        [itemTemplate]="itemTemplate">
                    </syn-picker>
                </mat-header-cell>
            </ng-container>

            <ng-container matColumnDef="assignmentGroupHNOForm">
                <mat-header-cell *matHeaderCellDef class="syn--padding-right">
                    <syn-picker
                        placeholder="Groupe d'affectation HNO"
                        formControlName="assignmentGroupHNO"
                        fxFlex="100"
                        subscriptSizing="dynamic"
                        [content]="assignmentGroupHNOFooter$"
                        [contentLoader]="assignmentGroupLoaderHNOFooter"
                        [itemTemplate]="itemTemplate">
                    </syn-picker>
                </mat-header-cell>
            </ng-container>

            <ng-container matColumnDef="actionsForm">
                <mat-header-cell *matHeaderCellDef class="syn--margin-left__small" fxFlex="15">
                    <button mat-flat-button color="accent" [disabled]="form.invalid" (click)="createAssignmentGroupConfig()">
                        Ajouter
                    </button>
                </mat-header-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns" [style.margin-bottom]="'0.5em'"></mat-header-row>
            @if (canEdit) {
                <mat-header-row *matHeaderRowDef="formColumns" class="form-row"></mat-header-row>
            }
            <mat-row *matRowDef="let row; columns: displayedColumns;" (mouseenter)="row.hover = true"
                (mouseleave)="row.hover = false">
            </mat-row>
        </mat-table>

    </form>
</mat-card>

<ng-template #itemTemplate let-assignmentGroup="content">
    <div fxLayoutAlign="space-between">
        <span class="syn-ellipsis">{{ assignmentGroup.name }}</span>
        <small>{{ assignmentGroup.source }}</small>
    </div>
</ng-template>
